// export const apiUrl = 'http://localhost:4000';

// export const apiUrl = process.env.REACT_APP_BACKEND;
export const apiUrl = "https://server.casewell.in"
// http://localhost:4000

// https://mysterious-refuge-52666.herokuapp.com